import { render, staticRenderFns } from "./DecimalRoundBehaviorEditor.vue?vue&type=template&id=a65b0966&scoped=true&"
import script from "./DecimalRoundBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./DecimalRoundBehaviorEditor.vue?vue&type=script&lang=ts&"
import style0 from "./DecimalRoundBehaviorEditor.vue?vue&type=style&index=0&id=a65b0966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65b0966",
  null
  
)

export default component.exports